'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Carat, RotateClockwise } from '../Icons';
import { CaretButton, PageNumberButton, PageNumberLink, PageNumbersWrapper, PaginationWrapper, } from './styles';
const PAGES_RANGE = 8;
const MIN_PAGE = 1;
const getPagesRange = (currentPage, maxPage, range) => {
    const maxRange = maxPage - 1;
    const safeRange = Math.min(maxRange, range);
    const startIndex = Math.min(maxPage - safeRange, currentPage - safeRange / 2);
    const safeStartIndex = Math.max(MIN_PAGE, startIndex);
    const rangeArray = Array.from({ length: safeRange + 1 });
    return rangeArray.map((_, index) => safeStartIndex + index);
};
export const Pagination = ({ currentPage, onChange, pagesCount, useFilledButtons = false, nextPageLabel, previousPageLabel, ...rest }) => {
    return (_jsxs(PaginationWrapper, { ...rest, children: [_jsx(CaretButton, { disabled: currentPage <= 1, onClick: () => onChange(currentPage - 1), "aria-label": previousPageLabel, children: _jsx(Carat, { rotateClockwise: RotateClockwise.Half }) }), _jsx(PageNumbersWrapper, { useFilledButtons, children: getPagesRange(currentPage, pagesCount, PAGES_RANGE).map(page => {
                    const isSelected = page === currentPage;
                    return useFilledButtons ? (_jsx(PageNumberButton, { isSelected, onClick: !isSelected ? () => onChange(page) : undefined, variant: isSelected ? 'filled' : 'black-on-white', children: page }, page)) : (_jsx(PageNumberLink, { role: 'button', isSelected: isSelected, onClick: !isSelected ? () => onChange(page) : undefined, onKeyDown: event => {
                            if (event.key === 'Enter' || event.key === ' ') {
                                event.preventDefault();
                                if (!isSelected)
                                    onChange(page);
                            }
                        }, children: page }, page));
                }) }), _jsx(CaretButton, { disabled: currentPage >= pagesCount, onClick: () => onChange(currentPage + 1), "aria-label": nextPageLabel, children: _jsx(Carat, {}) })] }));
};
export default Pagination;
//# sourceMappingURL=Pagination.js.map